import { Component, OnInit } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';

@Component({
  selector: 'ct-regex',
  template: '',
  styles: ['']
})
export class CtRegexComponent extends CtrlBaseComponent implements OnInit {

  private stringRegexPattern : string;
  private message : string;
  private regexPattern : RegExp;
  private isValid : boolean;

  //create getters and setters in one line
  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.regexPattern = new RegExp(this.stringRegexPattern);
  }

  public validateStringAgainstPattern(string: string): boolean {
    let result : boolean = this.regexPattern.test(string);
    this.isValid = result;
    return result;
  }

  //getters and setters
  getStringRegexPattern(): string { return this.stringRegexPattern; }
  getIsValid(): boolean { return this.isValid; }
  getMessage(): string { return this.message; }

  setIsValid(value: boolean) { this.isValid = value; }
  setStringRegexPattern(value: string) { this.stringRegexPattern = value; }
  setMessage(value: string) { this.message = value; }
}